// class ProjectText extends React.Component {

// 	render() {
// 		var project = this.props.project;

// 		return (
// 			<div className='project-text section__head'>
// 				<h1>{project.title}<span>.</span></h1>

// 				<div className='section__h' />

// 				<p>
// 					{project.subtitle}
// 				</p>

// 			</div>
// 		);
// 	}
// }

// export default ProjectText;

const ProjectText = ({ project }) => {

	return (
		<div className='project-text section__head'>
			<h1>{project.title}<span>.</span></h1>

			<div className='section__h' />

			<p>
				{project.subtitle}
			</p>
		</div>
	);
};

export default ProjectText;



// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectText.react.jsx